export default {
      id: "sample-data-usage",
      viewBox: "0 0 70.09 55.543",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#sample-data",
      toString: function () {
        return this.url;
      }
    }